enum MessageEnum {
	ERROR = 'error',
	SUCCESS = 'success',
}

enum AlertEnum {
	EMAIL = 'email',
	CELLPHONE = 'cellPhone',
	ADDRESS = 'address',
	NONE = 'none',
}

type StatusType = {
	type: AlertType;
	typeMessage: MessageType;
	status: boolean;
};
type AlertType = AlertEnum;
type MessageType = MessageEnum;

interface ChangeDataAlertStore {
	status: StatusType;
	setStatus: (status: StatusType) => void;
	reset: () => void;
}

export {MessageEnum, AlertEnum};
export type {StatusType, AlertType, MessageType, ChangeDataAlertStore};
